<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 54" :width="width" :height="height">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(0 8.372466)">
        <path
          fill="currentColor"
          d="M31.7747368 28.0582521c2.1204474-3.0109316 3.2899737-6.6279453 3.360079-10.3536987l-3.6111316-2.1479178c.0637105.5577534.1011316 1.1238904.1035 1.6991507.021079 3.8759178-1.4471053 7.5996986-4.0774737 10.3426027-2.6303684 2.7426576-6.2047894 4.2766028-9.9274737 4.2605754C9.84173684 31.8123616 3.54860526 25.2512384 3.5145 17.1507452c-.02107895-3.8759178 1.44710526-7.59969862 4.07747368-10.34235616C9.47605263 4.84416986 11.8456579 3.5037863 14.4061579 2.90485479l-3.267-2.7919726c-2.24455264.90443836-4.30863158 2.2869863-6.04255264 4.09487671C1.80781579 7.63638904-.02723684 12.2919781.00023684 17.1374301c.0421579 10.1261096 7.90863158 18.3281918 17.63478946 18.3866302 3.7409211.0172602 7.3866316-1.2257261 10.3931053-3.5432877l.0127895-.0101096 12.2786052 12.7903562c.6638684.7251781 1.6531579 1.0186027 2.5844211.7668493.9312631-.252 1.6581315-1.0094795 1.8992368-1.9792603.2411053-.9697808-.0416842-1.9994794-.7387105-2.690137L31.7747368 28.0582521z"
        />
      </g>
      <path
        fill="currentColor"
        d="M29.1770526 17.1511151l6.9352106 4.1249589-1.8348158-7.7796987 6.1216579-5.23208215-8.0696842-.6830137L29.1770526.24640274l-3.1521315 7.33487671-8.0696843.6830137 6.1214211 5.23208215-1.8348158 7.7796987z"
      />
    </g>
  </svg>
</template>

<script>
export default {
    props: {
        width: {
            default: '20px'
        },
        height: {
            default: '25px'
        }
    }
}
</script>